import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectDealerSelected } from 'app/pages/Header/selectors';
import { hasDealerContext } from 'utils/hasDealerContext';

export type CdpSettingsConfigurationBreadcrumb = {
  label: string;
  link?: string;
  isActive?: boolean;
};

export const useCdpSettingsConfigurationPage = () => {
  const location = useLocation();
  const selectedDealer = useSelector(selectDealerSelected);

  const breadcrumbsList = useMemo((): CdpSettingsConfigurationBreadcrumb[] => {
    const fromState = (
      location.state as {
        breadcrumbsList?: CdpSettingsConfigurationBreadcrumb[];
      } | null
    )?.breadcrumbsList;
    if (fromState?.length) {
      return fromState;
    }
    return [{ label: 'CDP Settings', isActive: true }];
  }, [location.state]);

  const returnTo = useMemo(() => {
    const fromState = (location.state as { returnTo?: string } | null)?.returnTo;
    return typeof fromState === 'string' && fromState.trim() ? fromState : null;
  }, [location.state]);

  const hasDealer = hasDealerContext(selectedDealer);
  const dealerObj =
    typeof selectedDealer === 'object' && selectedDealer !== null
      ? (selectedDealer as { site_title?: string; dealer?: string; _id?: string })
      : null;
  const dealerTitle = dealerObj?.site_title;
  const dealerId = dealerObj?.dealer || dealerObj?._id;

  return {
    breadcrumbsList,
    returnTo,
    hasDealer,
    dealerTitle,
    dealerId,
  };
};
